"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get extractDisplayNameFromEmail () {
        return extractDisplayNameFromEmail;
    },
    get normalizeEmail () {
        return normalizeEmail;
    },
    get sanitiseEmailContent () {
        return sanitiseEmailContent;
    }
});
const _inflection = /*#__PURE__*/ _interop_require_default(require("inflection"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Domains where dots in the local part are ignored by the provider.
 */ const GMAIL_DOMAINS = [
    'gmail.com',
    'googlemail.com'
];
function normalizeEmail(email) {
    const atIndex = email.lastIndexOf('@');
    if (atIndex === -1) return email.toLowerCase();
    let localPart = email.substring(0, atIndex).toLowerCase();
    let domain = email.substring(atIndex + 1).toLowerCase();
    // Strip plus addressing (user+tag → user)
    const plusIndex = localPart.indexOf('+');
    if (plusIndex !== -1) {
        localPart = localPart.substring(0, plusIndex);
    }
    // Gmail/Googlemail: dots in local part are insignificant
    if (GMAIL_DOMAINS.includes(domain)) {
        localPart = localPart.replace(/\./g, '');
        domain = 'gmail.com';
    }
    return `${localPart}@${domain}`;
}
// html encode string
const encode = (str)=>{
    return str == null ? void 0 : str.split('').map((char)=>`&#${char.charCodeAt(0)};`).join('');
};
const sanitiseEmailContent = (content)=>{
    var _content_replace;
    return content == null ? void 0 : (_content_replace = content.replace(/[<>&;?#,'"$]+/g, encode)) == null ? void 0 : _content_replace.replace(/\.|\/\/:/g, '<span>$&</span>');
};
const extractDisplayNameFromEmail = (email, display_name)=>{
    if (display_name) {
        return display_name;
    } else {
        const localPart = email.split('@')[0];
        const parts = localPart.split('.').filter((part)=>part.length > 0);
        const capitalizedParts = parts.map(_inflection.default.capitalize);
        return capitalizedParts.join(' ');
    }
};
